import React from 'react';

const Services = () => {
    return (
        <section className="relative bg-black text-white py-12 md:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 font-poppins overflow-hidden">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 -z-8">
                <img 
                    src="/assets/images/2150799695.jpg" 
                    alt="Background"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/80"></div>
            </div>
            <div className="container relative z-10 mx-auto max-w-7xl">
                <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
                    {/* Left Text Content */}
                    <div className="lg:w-1/2">
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold mb-6 leading-tight">
                            Comprehensive Real Estate Services
                        </h2>

                        <div className="space-y-4 text-gray-300 text-base sm:text-lg leading-relaxed">
                            <p>
                                At our core, we're committed to delivering exceptional real estate experiences. With years of industry 
                                expertise, we've established ourselves as a trusted partner for all your property needs. Our comprehensive 
                                services are designed to simplify your real estate journey while maximizing your investment potential.
                            </p>

                            <p>
                                We pride ourselves on staying ahead of market trends and leveraging cutting-edge technology to provide 
                                our clients with a competitive edge. Whether you're a first-time homebuyer, seasoned investor, or 
                                looking to sell your property, our dedicated team is equipped with the knowledge and resources to 
                                deliver outstanding results tailored to your specific goals.
                            </p>
                        </div>
                    </div>

                    {/* Right Image Section */}
                    <div className="lg:w-1/2 relative h-[500px] sm:h-[600px] lg:h-auto">
                        <div className="relative w-full h-full">
                            <img
                                src="assets/images/offerimg-1.jpg"
                                alt="Family Moving"
                                className="w-full h-full max-w-[400px] mx-auto lg:ml-auto lg:mr-0 object-cover rounded-xl shadow-lg"
                            />
                            <img
                                src="assets/images/offerimg-2.jpg"
                                alt="Living Room"
                                className="absolute -bottom-8 -left-8 sm:left-0 md:left-8 w-3/4 max-w-[320px] h-auto aspect-[4/3] object-cover rounded-xl shadow-lg border-4 border-black z-10"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;
